<p-dialog
  [(visible)]="visible"
  [draggable]="false"
  [modal]="true"
  [position]="position"
  [closeOnEscape]="true"
  [closable]="closable"
  [breakpoints]="breakpoints"
  (onShow)="onShow($event)"
  (onHide)="onHide($event)"
  [styleClass]="dialogClass"
  [maskStyleClass]="maskStyleClass"
  [contentStyleClass]="contentStyleClass">
  <ng-content select="[header]"></ng-content>
  <ng-content select="[footer]"></ng-content>
  <ng-content select="[content]"></ng-content>

  @if (header) {
    <ng-template pTemplate="header">
      <ng-container *ngTemplateOutlet="header"></ng-container>
    </ng-template>
  }

  @if (content) {
    <ng-template pTemplate="content">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </ng-template>
  }

  @if (footer) {
    <ng-template pTemplate="footer">
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    </ng-template>
  }
</p-dialog>
